import { getTemplateVoiceOpeningLine } from '@apps/web/lib/outreach_step_editor_utils';
import { type JoinedOutreachRead } from '@libraries/typescript/api_client';

type EditFormSeed = {
    readonly outreach_reason_choice: string | undefined;
    readonly outreach_reason_other: string;
    readonly openingLine: string;
    readonly smsMessage: string;
    readonly multiShiftHeader: string;
    readonly multiShiftItem: string;
    readonly recurrenceScheduleDescription: string;
};

export function buildEditFormSeed(outreach: JoinedOutreachRead): EditFormSeed {
    const metadata = outreach.outreach_metadata as Record<string, unknown>;
    const outreachReason =
        typeof metadata['callout_reason'] === 'string'
            ? (metadata['callout_reason'] as string)
            : '';
    let outreach_reason_choice: string | undefined;
    let outreach_reason_other = '';
    if (outreachReason.startsWith('Other: ')) {
        outreach_reason_choice = 'Other';
        outreach_reason_other = outreachReason.slice('Other: '.length);
    } else if (outreachReason) {
        outreach_reason_choice = outreachReason;
    }
    const openingLine =
        getTemplateVoiceOpeningLine({
            metadataSchema: metadata,
            outreachType: outreach.outreach_type,
            isMultiShift: outreach.shift_ids.length > 1,
        }) ?? '';
    return {
        outreach_reason_choice,
        outreach_reason_other,
        openingLine,
        smsMessage: '',
        multiShiftHeader: '',
        multiShiftItem: '',
        recurrenceScheduleDescription:
            typeof metadata['recurrence_schedule_description'] === 'string'
                ? (metadata['recurrence_schedule_description'] as string)
                : '',
    };
}
